module.exports = __webpack_public_path__ + "fonts/NespressoLucas-LightItalic.eot?v=f3538cee5cc2ddaa48357223d7fc8235";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-LightItalic.eot?
// module id = 657
// module chunks = 0